module.exports = __webpack_public_path__ + "b3cc6256e5079ba3601f8a1fafb3812d.pdf";